import { DownloadOutlined, EyeOutlined } from '@ant-design/icons'
import { Alert, Button, Space, Typography } from 'antd'
import { useRugReportOps } from 'pages/reporting/reports/rug/RugReportProvider'
import React from 'react'

const { Text } = Typography

/** Publish the latest draft as the official report PDF, or preview/download it once published. */
export const PublishPdfControls: React.FC = () => {
  const {
    pdfState,
    publishLatestDraftPDF,
    handleDownloadPublishedPdf,
    handlePreviewPublishedPdf,
    reportSignatures: { publishBlocker },
  } = useRugReportOps()

  return (
    <Space orientation='vertical' size='small' style={{ width: '100%' }}>
      <Text type='secondary'>
        Publish the signed draft as the official RUG inspection report PDF.
      </Text>
      {publishBlocker && (
        <Alert
          title='Publishing is blocked'
          description={publishBlocker}
          type='warning'
          showIcon
        />
      )}
      {!pdfState.hasPublishedPdf ? (
        <Button
          type='primary'
          danger
          icon={<DownloadOutlined />}
          onClick={() => publishLatestDraftPDF()}
          disabled={Boolean(publishBlocker)}
          loading={pdfState.isPublishing}>
          Publish Final PDF
        </Button>
      ) : (
        <Space wrap>
          <Button
            type='primary'
            icon={<DownloadOutlined />}
            onClick={handleDownloadPublishedPdf}>
            Download Published PDF
          </Button>
          <Button icon={<EyeOutlined />} onClick={handlePreviewPublishedPdf}>
            Preview Published PDF
          </Button>
          <Button
            onClick={() => publishLatestDraftPDF()}
            disabled={Boolean(publishBlocker)}
            loading={pdfState.isPublishing}>
            Update Published PDF
          </Button>
        </Space>
      )}
      {pdfState.hasPublishedPdf && (
        <Alert
          title='PDF Published'
          description='The official RUG inspection report PDF has been published and is available for download.'
          type='success'
          showIcon
        />
      )}
    </Space>
  )
}
